module.exports = __webpack_public_path__ + "static/table_arabic_3-351c27eed8fe7dada7054e09b8346dad.png";